
import axios from '../../utils/axios';



export const getTestCriterias = () => {
    return axios.get('/GetProductTestCriterias');
}
